<template>
  <header class="header">
    <navbar-main v-if="$route.name === 'home' || $route.name === 'purpose-case'
      || $route.name === 'dynamism-case' || $route.name === 'network-case'
      || $route.name === 'empowerment-case'"/>
    <navbar-empty v-else-if="$route.name === 'start'"/>
    <navbar-evaluation v-else/>
  </header>
</template>

<script>
import NavbarMain from '@/components/Navbar/Main';
import NavbarEvaluation from '@/components/Navbar/Evaluation';
import NavbarEmpty from '@/components/Navbar/Empty';

export default {
  components: { NavbarMain, NavbarEvaluation, NavbarEmpty },
};
</script>



// WEBPACK FOOTER //
// src/components/Header.vue